<template>
  <v-app>
    <v-main class="app-main">
      <router-view class="route-view" />
    </v-main>
  </v-app>
</template>

<script>
export default { name: "App" };
</script>

<style>
html, body, #app {
  height: 100%;
}

body {
  overflow: hidden;
}

* {
  user-select: none;
  -webkit-user-drag: none;
}

.v-application,
.v-application--wrap {
  min-height: 100vh;
}

.app-main {
  height: 100vh;
}

.route-view {
  height: 100%;
}
</style>
